import { ReactNode } from 'react';
import { Link } from '@common-components';
import { activeTabUrlParamValues, BrokerUrlParams } from 'broker/broker-routes';
import { useUpdateQueryParam } from 'broker/hooks';

export function ToolboxItemLink({
  children,
  entityId,
  itemType,
  onClick,
}: {
  children: ReactNode;
  entityId?: string;
  itemType: 'file' | 'email';
  onClick: () => void;
}) {
  const updateQueryParam = useUpdateQueryParam();

  const onLinkClicked = () => {
    if (!entityId) {
      return;
    }

    const activeTab = itemType === 'email' ? activeTabUrlParamValues.EMAIL : activeTabUrlParamValues.FILES;
    const paramName = itemType === 'email' ? BrokerUrlParams.SELECTED_EMAIL : BrokerUrlParams.SELECTED_FILE;

    const addParams = [
      { queryParam: BrokerUrlParams.ACTIVE_TAB, value: activeTab },
      { queryParam: paramName, value: entityId },
    ];

    updateQueryParam({
      removeParams: [BrokerUrlParams.ACTIVE_TAB, BrokerUrlParams.SELECTED_EMAIL, BrokerUrlParams.SELECTED_FILE],
      addParams,
    });

    onClick();
  };

  return (
    <Link underline="hover" sx={{ cursor: 'pointer' }} onClick={onLinkClicked}>
      {children}
    </Link>
  );
}
